<template>
    <AttachMaterial></AttachMaterial>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const AttachMaterial = defineAsyncComponent(() =>
    import(
        "../../../components/ProjectManagement/HelpPage/JobEntry/AttachMaterial.vue"
    )
);

export default {
    name: "Project_HelpAttachMaterial", //The name you are in should not equal the name of the component you are importing.
    components: { AttachMaterial, AuthLayout },
};
</script>
